export default __webpack_public_path__ + "static/media/Bolo-De-Arroz.78914258.jpg";